"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CustomSearchIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _icons = require("@material-ui/icons");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * Handles backward compatibility for search icon
 *
 * NOTE: type of 'image' is used for backward compatibility
 * default is the material-ui icon
 *
 * @param {object} props
 * @returns
 */
var CustomSearchIcon = function CustomSearchIcon(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _props$id = props.id,
    id = _props$id === void 0 ? 'global_search_input_find' : _props$id,
    classes = props.classes,
    onClick = props.onClick,
    type = props.type;
  if (type === 'image') {
    return /*#__PURE__*/_react.default.createElement("span", {
      id: id,
      className: classes.searchIconSpan,
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: classes.searchIcon,
      src: "https://raw.githubusercontent.com/CBIIT/datacommons-assets/main/bento/images/icons/svgs/globalSearchSearch.svg",
      alt: "search icon"
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_icons.Search, {
    id: id,
    className: classes.searchIconSpan,
    onClick: onClick
  });
};
exports.CustomSearchIcon = CustomSearchIcon;
var _default = CustomSearchIcon;
exports.default = _default;